export const CategoriaPai = {
  TipoDeProcesso: 1,
  AreaDeDireito: 2,
  Justica: 3,
  Instancia: 4,
} as const;
